module.exports = __webpack_public_path__ + "img/og-procreate-52.19ac3fa.jpg";